export default __webpack_public_path__ + "static/media/notAuthorisedViewImg.2d08a14f.png";